/**
 * Inertia 2.0 stores the current page on history.state. Vue 3 wraps that
 * object in reactive proxies whose __v_raw / __v_reactive pair is circular.
 * Chromium throws DataCloneError; iOS JavaScriptCore (Chrome iOS / Safari)
 * throws RangeError: Maximum call stack size exceeded instead.
 *
 * JSON.stringify only walks enumerable data keys, so it strips the proxies.
 *
 * @param {unknown} state
 * @returns {unknown}
 */
export function sanitizeHistoryState(state) {
    if (state == null || typeof state !== 'object') {
        return state;
    }

    try {
        return JSON.parse(JSON.stringify(state));
    } catch {
        const record = /** @type {Record<string, unknown>} */ (state);

        return {
            scrollRegions: Array.isArray(record.scrollRegions) ? record.scrollRegions : [],
            documentScrollPosition:
                record.documentScrollPosition && typeof record.documentScrollPosition === 'object'
                    ? record.documentScrollPosition
                    : { top: 0, left: 0 },
        };
    }
}
